export const doInfoMapClicks = () => {
    let infomaptitles = document.querySelectorAll(".tpt-state > h4.state");
    if(infomaptitles.length){
      for(let infotitle of infomaptitles){
        infotitle.addEventListener('click', infomapClick );
      }

      //map is driven by IDs within SVG - only the first added to a page will work
      let wrap = document.querySelector('.ktdamd-infomap-wrap')
      if(wrap) setInitialState(wrap)
    }
}

const closeControl = (title) => {
    let panel = title ? title.nextElementSibling : false;
    if(panel){
      title.classList.remove("expanded");
      if(panel.style.maxHeight){
          panel.style.maxHeight = null;
      }
    }
}

const toggleControl = (title) => {
    let panel = title ? title.nextElementSibling : false;
    if(panel){
      title.classList.toggle("expanded");
      if(panel.style.maxHeight){
          panel.style.maxHeight = null;
          return false;
      } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
          return true;
      }
    }
}

const infomap = document.getElementById('damd-info-map');
const infomap_areas = ["georgia", "tennessee", "north-carolina", "south-carolina"];
const infomap_colors = {
  "active": "#D61116",
  "named" : "#333333",
  "highlight": "#555555",
  "inactive": "#121212"
}

if (infomap) {
	infomap_areas.forEach(area => {
		const areaElement = infomap.querySelector(`#${area}`);

		areaElement.addEventListener('click', () => {
			const title = document.querySelector(`[data-map-target="${area}"]`);

			infomap_areas.forEach(state => {
				const activate = (area === state);
				const stateTitle = document.querySelector(`[data-map-target="${state}"]`);

				closeControl(stateTitle);
				activateInfoMapArea(state, activate);
			});

			toggleControl(title);
		});
	});
}


export const setInitialState = (elem) => {
  console.log("setting Initial State");
  let section = elem.classList.contains('ktdamd-infomap-wrap') ? elem : elem.closest('.ktdamd-infomap-wrap');
  if(!section) return false;

  let initial = section.hasAttribute('data-initial-state') ? section.dataset.initialState : false;
  if(!initial) return false;

  let states = section.querySelectorAll('h4.state');
  for(let state of states){
    if(typeof state.dataset.mapTarget !== "undefined" && state.dataset.mapTarget == initial) {
      state.click();
      return true;
    }
  }
}
const activateInfoMapArea = ( slug, make_active = true ) => {
    let domarea = document.getElementById(slug);
    if(domarea) {
      if(make_active) {
        domarea.style.fill = infomap_colors.active;
      } else {
        domarea.style.fill = infomap_colors.named;
      }
    }
}

export const infomapClick = (event) => {
    //just in case the plus icon is clicked on this event should cover both with bubbling
    let title = event.target.tagName === "H4" ? event.target : event.target.closest("H4");
    let parent = title.closest(".tpt-state");
    let panel = parent ? parent.querySelector(".tpt-state-panel") : false;
    let slug = title.hasAttribute('data-map-target') ? title.dataset.mapTarget : false;
    if(title && panel){
      //if no data-slug on the panel, toggle will still work just not select a map path
      //close any open panels
      let wrap = title.closest('.ktdamd-infomap-wrap');
      let allTitles = wrap ? wrap.querySelectorAll('.tpt-state > .state') : false;

      if(allTitles){
        for(let thisTitle of allTitles) {
            if(title !== thisTitle) {
                closeControl(thisTitle);
            }
        }
      }
      let is_open_click = toggleControl(title);
      for(var i=0;i<infomap_areas.length;i++){
        let area = infomap_areas[i];
        if(is_open_click) {activateInfoMapArea(area, (slug == area) ); } else {activateInfoMapArea(area, false );}
      }


    }
}
